module.exports = __webpack_public_path__ + "static/ha10-c02a95cd163516c4ff518ca6d7181f0b.jpg";